import React from 'react';

const FeaturesPageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/features',
			exact: true,
			component: React.lazy(() => import('./FeaturesPage')),
		},
	],
};

export default FeaturesPageConfig;
